import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../core'
import * as externalInstitutions from '../external-institutions'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from(
      externalInstitutions.RESOURCE.payload,
    ),
    description: 'The name of the entity as it appears in SAM.gov',
    isOptional: true,
    name: 'Name in SAM.gov',
    partialId: PartialId.Standard.create('sam_name'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
